import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import CloseIcon from '@mui/icons-material/Close';
import { Avatar, Fab, List, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import Chip from '@mui/material/Chip';
import { getUserFullName } from 'app/utils/appHelpers';
import config from '../../../config';

import { useSelector } from 'react-redux';
import { useTemplateFontSettings } from 'styles/templateFontSettings';

const CustomUserList = ({ epostaList = [], handleDeleteUser, title }) => {


  const { data: userList } = useSelector(state => state.user);
  const { baseFontSize, fabStyle } = useTemplateFontSettings();

  return (

    < JumboCardQuick
      title={<Typography variant='h6' sx={{ fontSize: baseFontSize }}> {title}
        <Chip label={epostaList.length} size={'small'} sx={{ fontSize: '10px' }} /></Typography >}
      wrapperSx={{
        py: 0,
        px: 1,
        height: '510px',
      }}

      headerSx={{ borderBottom: 1, borderBottomColor: 'divider', minHeight: '75px' }}

    >
      <JumboScrollbar
        autoHeight
        autoHeightMin={420}
        autoHide
        autoHideDuration={200}
        autoHideTimeout={500}
      >
        <List disablePadding>
          {epostaList.map((item, index) => {
            const user = userList.find(user => user.id === item.value); // Find user by item.value
            return (
              <ListItemButton
                key={index}
                component="li"
                sx={{
                  paddingRight: '5px',
                  paddingLeft: '5px',
                  borderBottom: 1,
                  borderBottomColor: 'divider'
                }}
              >
                <ListItemAvatar>
                  <Avatar
                    sx={fabStyle}
                    alt={user ? user.name : item.name} // Use found user's name
                    src={user && user.profileImageUrl ? `${config.userAuthApiUrl}${user.profileImageUrl}` : undefined}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl
                    }}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant='body1' mb={.5} sx={{ fontSize: baseFontSize }}>
                      {getUserFullName(user)} <Typography variant='caption' sx={{ fontSize: '0.8em', fontStyle: 'italic' }}>({user && user.email ? user.email : 'email yok'})</Typography>
                    </Typography>
                  }
                />
                {<ListItemIcon sx={{ minWidth: 32, ml: 2 }}>

                  <Fab
                    sx={{ ...fabStyle }}
                    size="small"
                    aria-label="Delete"
                    handleDeleteUser={(item)}
                    onClick={() => {
                      handleDeleteUser(item);
                    }}
                  >
                    <CloseIcon />
                  </Fab>

                </ListItemIcon>}
              </ListItemButton>
            );
          })}
        </List>

      </JumboScrollbar>




    </JumboCardQuick >

  );

}

export default CustomUserList;